// extracted by mini-css-extract-plugin
export default {"emptyWrapper":"practiceHistory_emptyWrapper__t3NLy"};